import * as React from 'react';

import Alert from 'antd/es/alert';

import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { Insurance } from '@app/objects/Insurance';
import { InsuranceCards } from '@app/components/Pages/Admin/InsuranceCards/InsuranceCards';

interface Props {
	renderButtons?: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit: () => void;
}

interface InsuranceStepWrapperProps extends Props {
	initialItems?: Array<Insurance>;
}

const InsuranceStep: React.FC<Props> = (props) => {
	const { state: { items } } = useItemsProviderContext<Insurance>();

	const [activeKey, setActiveKey] = React.useState('primary');

	React.useEffect(() => {
		if (items && items.length > 0 && items.some((ins) => ins.photoFront || ins.photoBack)) {
			handleSubmit();
		}
	}, []);

	const handleSubmit = () => {
		props.afterSubmit();
	};

	return <>
		<div className="contact-text mt10 mb10">
			<Alert
				message={<>
					Take photo of your
					{' '}
					<b>insurance card</b>
					.
				</>}
				type="info"
			/>
		</div>
		<InsuranceCards
			showOnlyPrimary
			onTabChange={setActiveKey}
			cardPanelClassName="patient-register-page__wrapper"
		/>
		{props.renderButtons && props.renderButtons(handleSubmit)}
	</>;
};

const InsuranceStepWrapper: React.FC<InsuranceStepWrapperProps> = (props) => {
	return (
		<ItemsProvider<Insurance>
			loadRequest="insurancePageViewList"
			items={props.initialItems}
		>
			<InsuranceStep {...props} />
		</ItemsProvider>
	);
};

export default InsuranceStepWrapper;
